const initialState = {
	contactsHistoryLogs: null,
	loading: false,
	error: null,
	loadNextContactsHistory: false,
	filters: {
		page: 1,
		pageSize: 50,
		query: '',
		action: '',
		groupId: '',
		startDate: null,
		endDate: null,
		domainLogs: false
	},
	upgradeRequired: null,
	actionLoading: false,
	actionSuccess: null,
	actionError: null
};

const contactsHistoryLogsReducer = ( state = initialState, action ) => {
	switch (action.type){
		case "FETCH_CONTACTS_HISTORY_LOGS_PENDING":
			return {
				...state,
				loading: true,
				error: null,
				filters: action.payload || state.filters
			};
		case "FETCH_CONTACTS_HISTORY_LOGS":
		case "FETCH_CONTACTS_HISTORY_LOGS_SUCCESS":
			return {
				...state,
				loading: false,
				contactsHistoryLogs: action.payload,
				error: null,
				upgradeRequired: null
			};
		case "FETCH_CONTACTS_HISTORY_LOGS_FAILURE":
			return {
				...state,
				loading: false,
				contactsHistoryLogs: null,
				error: action.payload
			};
		case "FETCH_CONTACTS_HISTORY_LOGS_UPGRADE_REQUIRED":
			return {
				...state,
				loading: false,
				upgradeRequired: action.payload
			};
		case "FETCH_NEXT_CONTACTS_HISTORY_LOGS":
		case "FETCH_NEXT_CONTACTS_HISTORY_LOGS_SUCCESS":
			return {
				...state,
				contactsHistoryLogs: {
					...state.contactsHistoryLogs,
					logs: [
						...(state.contactsHistoryLogs?.logs || []),
						...(action.payload?.logs || [])
					],
					pageInfo: action.payload?.pageInfo || state.contactsHistoryLogs?.pageInfo
				}
			};
		case "LOAD_NEXT_CONTACTS_HISTORY":
			return {
				...state,
				loadNextContactsHistory: action.payload
			};
		case "REVERT_CONTACT_HISTORY_PENDING":
		case "RESTORE_CONTACT_HISTORY_PENDING":
			return {
				...state,
				actionLoading: true,
				actionError: null,
				actionSuccess: null
			};
		case "REVERT_CONTACT_HISTORY_SUCCESS":
		case "RESTORE_CONTACT_HISTORY_SUCCESS":
			return {
				...state,
				actionLoading: false,
				actionSuccess: action.payload
			};
		case "REVERT_CONTACT_HISTORY_FAILURE":
		case "RESTORE_CONTACT_HISTORY_FAILURE":
			return {
				...state,
				actionLoading: false,
				actionError: action.payload
			};
		default:
			return state;
	}
};

export default contactsHistoryLogsReducer;

